import { useContext } from 'react';

import BusinessUnitParamsContext from '../../../contexts/BusinessUnitParamsContext/businessUnitParamsContext';
import { useStyles } from './styles';

const HeaderLogo = () => {
  const { logoWithoutAuthentication, portalConfigParams } = useContext(BusinessUnitParamsContext);
  const { newLogin } = portalConfigParams!;
  const classes = useStyles();

  const goToHome = () => {
    window.location.replace('/');
  };

  return (
    <img
      className={newLogin ? classes.logoNewLogin : classes.logo}
      src={logoWithoutAuthentication}
      alt={'Business-logo'}
      onClick={goToHome}
    />
  );
};

export default HeaderLogo;
